import { useGraphVisualisation } from '@/components/GraphVisualisation/hooks/useGraphVisualisation';
import DecisionReport from '@/components/DecisionReport/DecisionReport';

const Report = () => {
  const { graph, visible, report, goal } = useGraphVisualisation();

  if (!report) null;
  return (
    <div className="h-full w-full">
      <DecisionReport graph={graph} visible={visible} goal={goal} />
    </div>
  )
}

export default Report;
